import React from "react";
import "./../home/Order.css";
import { useUserTheme } from "src/shared/utils/useUserTheme";
import { CategoryButton } from "src/shared/services/interfacev2";

interface ProductCategoriesProps {
  categories: CategoryButton[];
  selectedCategoryId: string | undefined;
  backgroundColor: string;
  onCategorySelect: (id: string) => void;
  organizationName?: string;
}

const ProductCategories: React.FC<ProductCategoriesProps> = ({ categories, selectedCategoryId, backgroundColor, onCategorySelect }) => {
  const { fontClass, bgClass, borderHighlight } = useUserTheme();

  return (
    <div className="bg-[#F9F8FA] p-1 rounded-xl h-fit" id="product-categories">
      <div className="flex flex-col gap-2">
        {Array.isArray(categories) &&
          categories.map((item) => {
            const isSelected = selectedCategoryId === item._id.$oid;

            return (
              <button
                key={item._id.$oid}
                className={`
                  c-p-view w-full sm:w-16 md:w-20 lg:w-24 aspect-square rounded-lg px-2 py-2
                  text-center transition-all duration-300 ${bgClass} ${fontClass}
                  border-2 ${isSelected ? borderHighlight + " ring-2 ring-offset-2 shadow-md" : "border-transparent"}
                `}
                onClick={() => onCategorySelect(item._id.$oid)}
                id={`${item.name}-category-button`}
              >
                <span className="text-[16px] leading-tight text-center block break-words text-white">{item.name}</span>
              </button>
            );
          })}
      </div>
    </div>
  );
};

export default ProductCategories;
